var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes,attrs:{"title":_vm.$options.filters?.formatCurrencyAmount(_vm.value, 'idr', '0')}},[_vm._v(_vm._s(_vm._f("formatCurrencyAmount")(_vm.value,"idr", "0"))+" IDR")])
}
var staticRenderFns = []

export { render, staticRenderFns }